/* Rasterize the approved product proof. Geometry is supplied by the same
 * placement adapter as the live SVG; no names or layouts are solved here.
 * Keep the returned PNG Blob in memory until the cart transport uploads it.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory(require('./je-birthflower-product-artwork.js'));
  else root.BloomProductProof = factory(root.BloomProductArtwork);
})(typeof globalThis !== 'undefined' ? globalThis : this, function (artworkRenderer) {
  'use strict';
  const PIXELS = 1000;
  const failure = () => new Error('Your preview could not be prepared. Please review your bottles again.');
  async function render({ row, font, photo, artwork }, { createCanvas, loadImage, signal }) {
    const check=()=>{if(signal?.aborted)throw failure();};
    check();
    if (!row?.layout?.fits || !artwork?.fits || !font?.family || !Number.isFinite(font.unitsPerEm)) throw failure();
    const kind = photo ? 'bottle' : 'artwork';
    const flower = await loadImage({ url: artwork.flower.href });
    check();
    const bottle = photo ? await loadImage(photo) : null;
    check();
    const board = artwork.board;
    const view = photo ? { x: -50, y: -50, width: 1100, height: 1100 }
      : { x: -5, y: -8, width: board.width + 10, height: board.height + 16 };
    const canvas = createCanvas(), ink = createCanvas();
    canvas.width = canvas.height = ink.width = ink.height = PIXELS;
    const ctx = canvas.getContext('2d'), mask = ink.getContext('2d');
    if (!ctx || !mask) throw failure();
    const scale = Math.min(PIXELS / view.width, PIXELS / view.height);
    const x = (PIXELS - view.width * scale) / 2 - view.x * scale;
    const y = (PIXELS - view.height * scale) / 2 - view.y * scale;
    ctx.fillStyle = '#f3f5f7'; ctx.fillRect(0, 0, PIXELS, PIXELS);
    ctx.setTransform(scale, 0, 0, scale, x, y);
    if (photo) {
      const frame = photo.stageCropRect, crop = photo.crop;
      const source = { x: crop.x * photo.width, y: crop.y * photo.height,
        width: crop.width * photo.width, height: crop.height * photo.height };
      // Nested SVG viewBox uses xMidYMid meet. Preserve that exact photo fit.
      const meet = Math.min(frame.width * 1000 / source.width, frame.height * 1000 / source.height);
      const width = source.width * meet, height = source.height * meet;
      ctx.drawImage(bottle, source.x, source.y, source.width, source.height,
        frame.x * 1000 + (frame.width * 1000 - width) / 2,
        frame.y * 1000 + (frame.height * 1000 - height) / 2, width, height);
    }
    mask.setTransform(scale, 0, 0, scale, x, y);
    mask.translate(artwork.placement.x, artwork.placement.y);
    mask.scale(artwork.placement.xScale, artwork.placement.yScale);
    mask.beginPath(); mask.rect(0, 0, board.width, board.height); mask.clip();
    artworkRenderer.drawInk(mask, artwork, flower, font);
    // Match the SVG alpha mask and its silver tint, including flower edges.
    mask.setTransform(1, 0, 0, 1, 0, 0); mask.globalCompositeOperation = 'source-in';
    mask.fillStyle = artwork.color; mask.fillRect(0, 0, PIXELS, PIXELS);
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.drawImage(ink, 0, 0);
    const blob = await new Promise((resolve, reject) => {
      let settled=false;
      const finish=value=>{
        if(settled)return;settled=true;clearTimeout(timer);signal?.removeEventListener('abort',cancel);
        value?.size && value.type==='image/png'?resolve(value):reject(failure());
      };
      const cancel=()=>finish(null),timer=setTimeout(cancel,15000);
      signal?.addEventListener('abort',cancel,{once:true});
      if(signal?.aborted){cancel();return;}
      try { canvas.toBlob(finish,'image/png'); }
      catch { cancel(); }
    });
    return { blob, kind, width: PIXELS, height: PIXELS, filename: 'birthflower-preview.png' };
  }
  return Object.freeze({ render });
});
